import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const TestsDigitalLiteracy = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.digitalLiteracy}
        />
    );
};

export default TestsDigitalLiteracy;
